export default __webpack_public_path__ + "static/media/title.c2750d77.gif";